// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Mario World Universe - Warp Gates Configuration
 * 
 * Warp Pipes connecting the Mushroom Kingdom to other dimensions.
 */

export const warpGates = [
  {
    id: 'gate_marioworld_to_pokemon',
    name: 'Ultra Warp Pipe',
    type: 'warpgate',
    description: 'A special warp pipe that leads to a universe filled with pocket monsters. Mama mia!',
    distance: 25, // Distance from Mushroom Kingdom
    destinationUniverse: 'pokemon',
    destinationGate: 'gate_pokemon_to_marioworld',
    toSystem: 600, // Kanto Prime
    fuelRequired: 5,
    discovered: false,
    threat: 'SAFE',
    resources: 'WARP PIPE GATEWAY',
    services: [],
    primaryColor: '#00FF00',
    secondaryColor: '#FF0000',
    hasRings: true,
    animated: true
  },
  {
    id: 'gate_marioworld_to_sonicuniverse',
    name: 'Speed Pipe',
    type: 'warpgate',
    description: 'A blue warp pipe surrounded by golden rings. Gotta go fast!',
    distance: 25, // Distance from Mushroom Kingdom
    destinationUniverse: 'sonicuniverse',
    destinationGate: 'gate_sonicuniverse_to_marioworld',
    toSystem: 2000, // Green Hill Zone
    fuelRequired: 5,
    discovered: false,
    threat: 'SAFE',
    resources: 'WARP PIPE GATEWAY',
    services: [],
    primaryColor: '#0066FF',
    secondaryColor: '#FFCC00',
    hasRings: true,
    animated: true
  },
  {
    id: 'gate_marioworld_to_zelda',
    name: 'Triforce Pipe',
    type: 'warpgate',
    description: 'A mystical green warp pipe adorned with golden Triforce symbols. Legend awaits!',
    distance: 28, // Distance from Mushroom Kingdom
    destinationUniverse: 'zelda',
    destinationGate: 'gate_zelda_to_marioworld',
    toSystem: 1200, // Hyrule Kingdom
    fuelRequired: 5,
    discovered: false,
    threat: 'SAFE',
    resources: 'WARP PIPE GATEWAY',
    services: [],
    primaryColor: '#00AA00',
    secondaryColor: '#FFD700',
    hasRings: true,
    animated: true
  },
  {
    id: 'gate_marioworld_to_digiworld',
    name: 'Digital Warp Pipe',
    type: 'warpgate',
    description: 'Digital Warp Pipe - A glitched pipe crackles with digital energy. Mario meets Digimon.',
    distance: 22, // Distance from Mushroom Kingdom
    destinationUniverse: 'digiworld',
    destinationGate: 'gate_digiworld_to_marioworld',
    toSystem: 900, // File Island
    fuelRequired: 5,
    discovered: false,
    threat: 'SAFE',
    resources: 'WARP PIPE GATEWAY',
    services: [],
    primaryColor: '#00FF00',
    secondaryColor: '#FF0000',
    hasRings: true,
    animated: true
  }
];

// Warp gate positions for map visualization
export const warpGatePositions = {
  'gate_marioworld_to_pokemon': { x: 45, y: 50, z: 5 },   // Near Mushroom Kingdom
  'gate_marioworld_to_sonicuniverse': { x: 50, y: 60, z: 5 },   // 25 LY from Mushroom Kingdom
  'gate_marioworld_to_zelda': { x: 40, y: 50, z: 5 },   // 28 LY from Mushroom Kingdom
  'gate_marioworld_to_digiworld': { x: 45, y: 60, z: 5 }   // 22 LY from Mushroom Kingdom
};